var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from "react";
import Select from "react-select/creatable";
import { ReactSelectCustomComponents, useReactSelectQuinineClassnames } from "../QuiSelect/react-select.js";
import { QuiIcon } from "../_primitives/QuiIcon/QuiIcon.js";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function PressEnter({ selectProps }) {
    return selectProps.inputValue ? (React.createElement("span", { className: "qui-text-xs" },
        React.createElement(QuiIcon, { size: "sm", icon: "corner-down-left", className: "qui-color-blue" }))) : null;
}
const customComponents = Object.assign(Object.assign({}, ReactSelectCustomComponents), { DropdownIndicator: PressEnter });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function defaultTagComparator(tag1, tag2) {
    return tag1.value === tag2.value;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function QuiTagInput(_a) {
    var { size, disabled, invalid, onChange, value, breakCharacters, disableSubmitOnBlur, parseTag, onBlur, tagComparator = defaultTagComparator } = _a, otherProps = __rest(_a, ["size", "disabled", "invalid", "onChange", "value", "breakCharacters", "disableSubmitOnBlur", "parseTag", "onBlur", "tagComparator"]);
    const [inputValue, setInputValue] = React.useState("");
    const submitTag = useCallback(() => {
        if (!inputValue)
            return;
        const option = parseTag(inputValue.trim());
        // only add the tag if it's not already in the list
        if (!value.some((v) => tagComparator(option, v))) {
            onChange === null || onChange === void 0 ? void 0 : onChange([...value, option], { action: "create-option", option });
        }
        setInputValue("");
    }, [inputValue, value, parseTag, onChange, tagComparator]);
    const handleKeyDown = useCallback((event) => {
        if (!inputValue)
            return;
        if (event.key === "Enter" || event.key === "Tab" || ((breakCharacters === null || breakCharacters === void 0 ? void 0 : breakCharacters.length) && breakCharacters.includes(event.key))) {
            submitTag();
            event.preventDefault();
        }
    }, [inputValue, breakCharacters, submitTag]);
    const handleBlur = useCallback((event) => {
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
        if (!inputValue || disableSubmitOnBlur)
            return;
        submitTag();
        event.preventDefault();
    }, [disableSubmitOnBlur, inputValue, submitTag, onBlur]);
    const reactSelectClassNames = useReactSelectQuinineClassnames({ size, invalid });
    return (React.createElement(Select, Object.assign({ size: size }, otherProps, { components: customComponents, inputValue: inputValue, isDisabled: disabled, unstyled: true, classNames: reactSelectClassNames, isClearable: true, isMulti: true, menuIsOpen: false, value: value, onChange: (newValue, actionMeta) => onChange === null || onChange === void 0 ? void 0 : onChange(newValue, actionMeta), onInputChange: (newValue) => setInputValue(newValue), onKeyDown: handleKeyDown, onBlur: handleBlur })));
}
